var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { AppProvider } from './contexts/AppContextProvider';
import './index.css';
export function render(configs) {
    var root = ReactDOM.createRoot(document.getElementById('okay-chat-app'));
    root.render(_jsx(React.StrictMode, { children: _jsx(AppProvider, __assign({ appConfig: configs }, { children: _jsx(App, {}) })) }));
}
